import logo from './logo.svg';
import './App.css';
import SubscriptionForm from './SubscriptionForm';

function App() {
  return (
    
    <div className="App">
      {/* <header className="App-header">
    
      </header> */}

      <div className="bgcycle">
        <div className="section">
          <video className="heroVideo" src="HeroVideo.mp4" autoPlay loop />
          <div className="container">
            <div className="row justify-content-center " >
                <div className="row justify-content-center my-5 w-75" >
                    <img src="logomotion_white.png" className="logoImgHero"/>
                </div>
                <div className="row text-center">
                  <h3 className="text-white">Stunning logo animations made in seconds with a few clicks</h3>
                </div>
            </div>
          </div>
        </div>
        <div className='halfSection'>

        <h2 className="text-center font-weight-bold my-4 w-100" >See how it works</h2>

          <div className='row justify-content-center align-items-center'>
            <div className='col imageSteps'>
              <img src='steps_upload.png' className='imageSteps'></img>
              <p>Upload a logo</p>
            </div>
            <div className='col imageSteps'>
              <img src='steps_select.png' className='imageSteps'></img>
              <p>Select animation templates</p>
            </div>
            <div className='col imageSteps'>
              <img src='steps_render.png' className='imageSteps'></img>
              <p>Click render</p>
            </div>
          </div>
          <div className='row justify-content-center'>
            {/* INCLUDE VIDEO HERE */}
          </div>
        </div>
        <div className='halfSection'>
        <div className="row justify-content-center">
        <h2 className="text-center font-weight-bold my-5 w-100" >Coming Soon...</h2>
            <SubscriptionForm />
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
